import { THEME_NAMES } from "./config";
import { assetPackIds } from "nemuru-components";

export const citiserviTheme = {
  zendeskCustomerSupport: false,
  themeName: THEME_NAMES.citiservi,
  logoUrl:
    "https://mcusercontent.com/9fe5713c5d971de550dce4ea7/images/5968ce68-87ee-c755-a361-3d698ad116f0.png",
  palette: {
    primary: {
      main: "#37D0A0",
      contrastText: "#ffffff",
    },
    secondary: {
      main: "#212529",
      contrastText: "#ffffff",
    },
    dark: {
      main: "#eeeeee",
      contrastText: "#212529",
      accent: "#F0AB5C",
      imageBackgroundOpacity: 0.85,
    },
    info: {
      main: "#F0AB5C",
      light: "#fbf4ed",
    },
    success: {
      main: "#37D0A0",
    },
    text: {
      title: "#212529",
      primary: "#4b5354",
      secondary: "#77787b",
    },
    status: {
      active: "#37d0a0",
      approved: "#189e74",
      analysing: "#36a3f7",
      sent: "#08404d",
      cancelled: "#d8d8d8",
      denied: "#ef5957",
    },
  },
  assetPackDefsId: assetPackIds.OUTLINED,
  background: "#f6f6f6",
  shadows: [
    "none",
    "none",
    "none", // 2 buttons
    "none", // 3 papers soft
  ],
  customBorderRadius: {
    button: 6,
    paper: 6,
    chip: 10,
  },
  typography: {
    fontFamily: "'Montserrat', sans-serif",
  },
};
